import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import './About.css';

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="about">
      <section className="about-hero hero-section">
        <div className="container">
          <h1>{t('aboutHero')}</h1>
          <p>{t('aboutTagline')}</p>
        </div>
      </section>

      <section className="about-content-section">
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              <h2>{t('ourStory')}</h2>
              <p>{t('story1')}</p>
              
              <p>{t('story2')}</p>
              
              <h3>{t('ourMission')}</h3>
              <p>{t('missionText')}</p>
              
              <h3>{t('ourVision')}</h3>
              <p>{t('visionText')}</p>
            </div>
            
            <div className="content-stats">
              <div className="stat-item">
                <h4>25+</h4>
                <p>{t('yearsExperience')}</p>
              </div>
              
              <div className="stat-item">
                <h4>500+</h4>
                <p>{t('satisfiedCustomers')}</p>
              </div>
              
              <div className="stat-item">
                <h4>30+</h4>
                <p>{t('productsAvailable')}</p>
              </div>
              
              <div className="stat-item">
                <h4>100%</h4>
                <p>{t('customerSupport')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <div className="section-title">
            <h2>{t('ourValues')}</h2>
            <p>{t('valuesDesc')}</p>
          </div>
          
          <div className="values-grid">
            <div className="value-card">
              <i className="fas fa-medal"></i>
              <h3>{t('quality')}</h3>
              <p>{t('qualityd')}</p>
            </div>
            
            <div className="value-card">
              <i className="fas fa-handshake"></i>
              <h3>{t('integrity')}</h3>
              <p>{t('integrityd')}</p>
            </div>
            
            <div className="value-card">
              <i className="fas fa-lightbulb"></i>
              <h3>{t('innovation')}</h3>
              <p>{t('innovationd')}</p>
            </div>
            
            <div className="value-card">
              <i className="fas fa-users"></i>
              <h3>{t('community')}</h3>
              <p>{t('communityd')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="benefits-section">
        <div className="container">
          <div className="section-title">
            <h2>{t('benefitsTitle')}</h2>
            <p>{t('benefitsDesc')}</p>
          </div>
          
          <div className="benefits-grid">
            <div className="benefit-card">
              <i className="fas fa-heart"></i>
              <h3>{t('improvedHealth')}</h3>
            </div>
            
            <div className="benefit-card">
              <i className="fas fa-chart-line"></i>
              <h3>{t('enhancedProductivity')}</h3>
            </div>
            
            <div className="benefit-card">
              <i className="fas fa-dollar-sign"></i>
              <h3>{t('costEffective')}</h3>
            </div>
            
            <div className="benefit-card">
              <i className="fas fa-leaf"></i>
              <h3>{t('naturalIngredients')}</h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;